import { StatusBar, Style } from "@capacitor/status-bar";
import { isNative } from "./capacitor";

export async function syncStatusBar(dark: boolean): Promise<void> {
  if (!isNative()) return;
  try {
    await StatusBar.setStyle({ style: dark ? Style.Dark : Style.Light });
  } catch {
    /* plugin unavailable */
  }
}
